// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentQuartoCaracteristicas_sectionTitle__3b4Jo","placeholderShimmer":"MainContentQuartoCaracteristicas_placeholderShimmer__14ZbH"};